import React from 'react'

const PopUp = () => {
  return (
    <>

      {/* PopUp */}

      <div className="container" style={{ marginBottom: "" }}>
        <div className="row">
          <div className="col-md-12">
            <div className="modal" id="mypopUpForm">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 style={{ color: '#000' }}>
                      <i className="fa fa-school" style={{ color: "red" }}> </i>  <span style={{ color: 'red' }}> Welcome to  Priyadarshani Convent High School  !</span></h5>
                    {/* <button style={{ color: "#0f903f" }} className="close" data-dismiss="modal"><b style={{ color: "#0f903f" }}>X</b></button> */}
                  </div>
                  <div className="modal-body">
                    <section id="features" className="features" >
                      <div className="" data-aos="fade-up" >
                        <div className="row">
                          <div className="col-lg-12" data-aos="fade-left" data-aos-delay={100} >
                            <b style={{ textAlign: "center", color: "#0f903f", fontSize: "20px" }}><p><b>Time:-</b> 09 AM to 02 PM</p></b>
                            <img className='' src="assets/img/Earth_1.webp" alt style={{ marginTop: "-50px", borderRadius: "10px" }} />
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </>
  )
}

export default PopUp